import { useUiVersion } from 'hooks';
import { Rfid } from 'grids/rfid/rfid';

export const RfidWrapper = (props) => {
  const { isNew } = useUiVersion();
  const theme = isNew ? undefined : 'dark';
  return <Rfid {...props} theme={theme} className="in-client" />;
};
